export default {};
throw new Error(`Could not resolve "three/examples/jsm/environments/RoomEnvironment.js" imported by "@appletosolutions/reactbits". Is it installed?`)